import React from 'react';

class InputGroup extends React.Component {

  render() {
    //console.log('InputGroup Render');
    return (
      <tr>
        {
          this.props.placeholders.map( (placeholder, index, arr) => {
            if(index == this.props.placeholders.length -1 ){
              return <td key={index}>
                        <button 
                          className="btn btn-danger btn-xs" 
                          onClick={this.props.onSave}>
                            Save
                        </button>
                     </td>
            }


            return <td key={index}>
                        <input
                          ref={placeholder[0].toLowerCase() + placeholder.substr(1)} 
                          className="form-control"  
                          placeholder={placeholder}/>
                   </td>
          })
        }
      </tr>
    )
  }

}

InputGroup.propTypes = ({
  onSave : React.PropTypes.func.isRequired,
  placeholders : React.PropTypes.array.isRequired,
});


export default InputGroup;


// WEBPACK FOOTER //
// ./src/components/InputGroup.js